import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Table, Modal, Badge } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
// import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
// import '../../../mcss/common.css';
import RequestHeader from '../RequestHeader';
import $ from 'jquery';
import Ad1RequestHeader from './Ad1RequestHeader';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import AD1TransactionComment from './AD1TransactionComment';


function Ad1AdditionalDetails(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [entityType, setEntityType] = useState(sessionStorage.entityType);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [reqSrNo, setReqSrNo] = useState(0);
    const [reqQuantity, setReqQuantity] = useState(0);
    const [reqCoverBank, setReqCoverBank] = useState("0");
    const [ddCoverBank, setDdCoverBank] = useState([]);
    const [reqCoverBankName, setReqCoverBankName] = useState("");
    const [reqCoverValue, setReqCoverValue] = useState("");
    const [reqCoverRate, setReqCoverRate] = useState("");
    const [reqCoverDeal, setReqCoverDeal] = useState("");
    const [reqCoverValDate, setReqCoverValDate] = useState(new Date());
    const [reqAddiDetFinal, setReqAddiDetFinal] = useState(0);
    const [coverListData, setCoverListData] = useState([]);
    const [reqCoverTotValue, setReqCoverTotValue] = useState(0);
    // const [reqData, setReqData] = useState([]);
    const [showReject, setShowReject] = useState(false);
    const [chngQtyListData, setChngQtyListData] = useState([]);
    const [rightAprovQty, setRightAprovQty] = useState([]);
    const [showConfirmBox, setShowConfirmBox] = useState(false);
    const [remark, setRemark] = useState("");
    const [viewObj, setViewObj] = useState("");
    const [reqDocVerify, setReqDocVerify] = useState([]);
    const [reqPurpose, setReqPurpose] = useState("0");
    const [reqDocId, setReqDocId] = useState("0");
    // const [reqDocName, setReqDocName] = useState("0");
    const [ddReqDocOptions, setDdReqDocOptions] = useState([]);
    const [reqDocRemark, setReqDocRemark] = useState("");
    const [docListData, setDocListData] = useState([]);
    const [reqDocumentsFinal, setReqDocumentsFinal] = useState(0);
    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'AD1ADDITIONALDETAILS'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiAd1, [sid, 'view', JSON.stringify({ srno: props.srno })], function (result) {
                        let resp = JSON.parse(result);
                        console.log(resp);
                        setViewObj(resp[0]);
                        setReqCoverBank(resp[0].trad_bank_code);
                        setReqCoverValue(resp[0].trad_quantity);
                        setReqSrNo(resp[0].trad_srno);
                        setReqQuantity(resp[0].trad_quantity);
                        setReqPurpose(resp[0]?.trad_purpose);
                        setReqAddiDetFinal(resp[0].trad_additional_detail_final);
                        // setReqCoverTotValue(resp[0].trad_quantity);
                        setReqCoverBankName(resp[0].issuer_name);
                        Common.callApi(Common.apiad1coverrate, [sid, 'list', props.srno], function (result) {
                            var arr = JSON.parse(result)
                            setCoverListData(arr);
                            //add all cbalue to total
                            setReqCoverTotValue(arr.reduce((a, b) => a + (b.cvalue * 1), 0));
                            setReqCoverTotValue(arr[0].cvalue);
                        });
                        Common.callApi(Common.apiAddDetails, [sid, 'kycdoclist', resp[0]?.trad_purpose], function (result4) {
                            let resp4 = JSON.parse(result4);
                            setDdReqDocOptions(resp4);
                        });
                    });
                    Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
                        let parsed = JSON.parse(result || "[]");
                        setDdCoverBank(Array.isArray(parsed) ? parsed : []);
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'APRCHANGEQTY'], function (result1) {
                        setRightAprovQty(JSON.parse(result1));
                    });
                    Common.callApi(Common.apiAd1, [sid, 'getDoc', JSON.stringify({ srno: props.srno, pageright: 'AD1ADDITIONALDETAILS' })], function (result) {
                        let parsed = JSON.parse(result || "[]");
                        setDocListData(parsed || []);
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    // function handleReqCoverBank(v, t) {
    //     setReqCoverBank(v);
    //     setReqCoverBankName(t);
    // }

    function btnBackClick() {
        props.callAd1();
    }
    // function btnDraftClick() {
    //     saveDocFinal("D");//D means draft
    // }
    function btnFinalClick() {
        setShowConfirmBox(true);
    }

    function saveDocFinal() {
        setShowConfirmBox(false);
        let object1 = {
            srno: props.srno,
            saveMode: 'F'
        }
        Common.callApi(Common.apiAd1, [sid, 'AddiDetailFinal', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp?.status) {
                setMsgText(resp.msg);
                setMsgBox(true);
                setShowConfirmBox(false);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        });
    }


    function btnRejectClick() {
        var object1 = {
            srno: reqSrNo
        }
        Common.callApi(Common.apiad1coverrate, [sid, 'reject', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setReqAddiDetFinal(1);
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        });
    }


    function handleShowReject() {
        setShowReject(!showReject);
    }

    function btnUnlockAddiDetail() {
        var object1 = {
            srno: reqSrNo
        }
        Common.callApi(Common.apiAd1, [sid, 'unlockAdditional', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.status === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                reqAddiDetFinal(0)
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        });
    }

    function isAddDocumentFinal() {
        // return !(reqDocumentsFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1));
        return !(userRight.add * 1 === 1 || userRight.edit * 1 === 1);
    }
    function downloadPaxList(reqCoverBank) {
        var object1 = {
            srno: 23,
            reqCoverBank: reqCoverBank
        }
        Common.callDownloadApiPost(Common.apiFormat, "post", [sid, 'ad1Paxlist', JSON.stringify(object1)]);
    }
    function btnUploadFile() {
        $('.loader').show();
        if (document.getElementById('fileToUpload').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else {
            var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');
            if (reqDocId === "0") {
                $('.loader').hide();
                setMsgText("Please fill document name.");
                setMsgBox(true);
            } else if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0] === undefined) {
                $('.loader').hide();
                setMsgText("Please select a file to upload.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else {
                var object1 = {
                    sid: sid,
                    uploadType: 'AD1KYCDOCUMENT',
                    srno: props.srno,
                    pageright: 'AD1ADDITIONALDETAILS',
                    docid: reqDocId,
                    remark: reqDocRemark,
                    reqCoverBank: reqCoverBank
                }
                Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
                    let resp = JSON.parse(result);
                    $('.loader').hide();
                    if (resp.error === "") {
                        setDocListData(resp.docdetail);
                        alert(resp.message);
                        setReqDocId("0");
                        setReqDocRemark("");
                    } else {
                        alert(resp.error);
                    }
                });
            }
        }

    }

    function btnDeleteDocumentClick(srno, docid, filename) {
        var object1 = {
            srno: srno,
            filename: filename,
            docid: docid,
            pageright: 'AD1ADDITIONALDETAILS'
        }
        Common.callApi(Common.apiAd1, [sid, 'docremove', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.error === "") {
                alert(resp.message);
            } else {
                alert(resp.error);
            }
            setDocListData(resp.docdetail);
        });
    }

    function btnDocumentView(srno, filename) {
        $('.loader').show();
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiAd1, [sid, 'viewDoc', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {

        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>Ad1 Additional Details</h1>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row> */}
                    <Row>
                        <Col>
                            <Ad1RequestHeader back={btnBackClick} viewData={viewObj}></Ad1RequestHeader>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5>Documents</h5>
                        </Col>
                    </Row>
                    {
                        entityType === "B" ?
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Document Verification</Form.Label>
                                        <Form.Select
                                            value={reqDocVerify}
                                            onChange={(e) => setReqDocVerify(e.target.value)}
                                            disabled={isAddDocumentFinal()}
                                        >
                                            <option value="U" >Upload</option>
                                            <option value="S" >Seen and Verify</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>&nbsp;</Col>
                                <Col>&nbsp;</Col>
                                <Col>&nbsp;</Col>
                            </Row>

                            : null

                    }
                    {
                        reqPurpose === "14" ? <>
                            <Row>
                                <Col>
                                    <Badge bg="danger" >List of Travellers in excel is mandatory to upload for Tour Purpose.</Badge>
                                </Col>
                            </Row>
                        </> : null
                    }
                    {isAddDocumentFinal() ? null :
                        <>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            Document Name
                                            {
                                                reqDocId === "23" ? <>
                                                    <Badge className="handCursor" bg="primary" onClick={(e) => downloadPaxList(reqCoverBank)}>
                                                        Download Format
                                                    </Badge>
                                                </> : null
                                            }
                                        </Form.Label>
                                        <Form.Select value={reqDocId} onChange={(e) => setReqDocId(e.target.value)}                                        >
                                            {ddReqDocOptions.map((res) =>
                                                <option key={res.value} value={res.value}>{res.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Remark</Form.Label>
                                        <Form.Control type="text" value={reqDocRemark}
                                            onChange={(e) => setReqDocRemark(e.target.value)}
                                        ></Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId='fileToUpload'>
                                        <Form.Label>File (Max 10MB)</Form.Label>
                                        <Form.Control type="file"></Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnUploadFile()} >Upload</Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                    }
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>Type</td>
                                        <td>Remark</td>
                                        <td>File Name</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docListData.map((res) =>
                                        <tr key={res.doc_filename}>
                                            <td>
                                                {
                                                    reqDocumentsFinal * 1 === 0 && res.doc_approved * 1 === 0 ?
                                                        <>
                                                            <div className="colorThemeBlue">
                                                                <span className="handCursor" onClick={(e) => btnDeleteDocumentClick(res.doc_srno, res.doc_id, res.doc_filename)}>
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </span>
                                                            </div>
                                                        </>
                                                        : null
                                                }

                                            </td>
                                            <td className='divHide'>{res.doc_srno}</td>
                                            <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                            <td>{res.doc_remark}</td>
                                            <td>{res.doc_filename}</td>
                                            <td>
                                                <div className="colorThemeBlue">
                                                    {
                                                        (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                            || res.doc_ext === "jpg" || res.doc_ext === "png") ? <>
                                                            <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>&nbsp;
                                                        </> : null
                                                    }

                                                    <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faFileDownload} />
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                            {
                                (reqAddiDetFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1)) &&
                                <>
                                    <Button variant="outline-success" size="sm" onClick={(e) => btnFinalClick()} >Final</Button>&nbsp;
                                </>
                            }
                            {
                                // && reqData.req_bankfilegenrated * 1 === 0
                                (userRight.add * 1 === 1) &&
                                    <>
                                        <input type="checkbox" checked={showReject} onChange={handleShowReject} />
                                        {showReject &&
                                            <>
                                                <Button variant ="outline-danger" size="sm" onClick={(e) => btnRejectClick()}>Reject</Button>
                                                &nbsp;
                                                <Button variant="outline-danger" size="sm" onClick={(e) => btnUnlockAddiDetail()}>Unlock Additional Detail</Button>
                                            </>
                                        }
                                    </>
                            }
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col xs={6}>
                            <Form.Group >
                                <Form.Label>Comment</Form.Label>
                                <Form.Control type="text" placeholder="Comment" maxLength={100}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setRemark)}
                                    value={remark} autoComplete="off" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group >
                                <Form.Label>&nbsp;</Form.Label><br></br>
                                <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row> */}
                    <Row>
                        <Col>
                            <AD1TransactionComment srno={props.srno} rc={refreshCounter}></AD1TransactionComment>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal show={showConfirmBox} onHide={() => setShowConfirmBox(false)} centered            >
                <Modal.Header>
                    <Modal.Title>Additional Document Final Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Are you sure to lock the Addition Document? Addition Document can not be modified.
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={(e) => saveDocFinal()} >Yes</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button variant="outline-danger" size="sm" onClick={(e) => setShowConfirmBox(false)} >No</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default Ad1AdditionalDetails;